/**
 * Generic selector for DRY and quick usage
 * @param state
 */
export var getByTypeAndId = function (state) {
    return function (type, id) {
        return state.domain[type] ? state.domain[type][id] : null;
    };
};
